/* eslint-disable */
export default {
  logged: 'Protokolliert',
  unlogged: 'Unbearbeitet',
  faxNotSupported: 'Faxprotokollierung wird nicht unterstützt.',
} as const;

// @key: @#@"logged"@#@ @source: @#@"Logged"@#@
// @key: @#@"unlogged"@#@ @source: @#@"Unworked"@#@
// @key: @#@"faxNotSupported"@#@ @source: @#@"To log fax is not supported."@#@
